import React from "react";
import "./Dashboard_buckets.css";
import Dashboard_buckets_card from "../../../../../common_components/dashboard_buckets_card/Dashboard_buckets_card";

function Dashboard_buckets() {
  // Data Array
  const bucketData = [
    {
      imgSrc: "/assets/images/icon/docs.webp",
      number: "25",
      heading_text: "Applications",
      text: "12 Active 8 accepted"
    },
    {
      imgSrc: "/assets/images/icon/open_file.webp",
      number: "12",
      heading_text: "Documents",
      text: "12 of 18 Uploaded"
    },
    {
      imgSrc: "/assets/images/icon/doller_doc.webp",
      number: "€800",
      heading_text: "Billing",
      text: "Invoice Pending"
    },
    {
      imgSrc: "/assets/images/icon/profile_2.webp",
      number: "85%",
      heading_text: "Profile",
      text: "Complete your Profile"
    },
  ];

  return (
    <>
      <section className="Dashboard_buckets">
        <div className="heading_text_holder">
          <h2>Welcome Priyank</h2>
        </div>

        <div className="row">
          {bucketData.map((item, index) => (
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 mb-3" key={index}>
              <Dashboard_buckets_card
                imgSrc={item.imgSrc}
                number={item.number}
                heading_text={item.heading_text}
                text={item.text}
              />
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default Dashboard_buckets;
